import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { deliveriesAPI } from '../services/api';
import './DeliveryDetail.css';

function DeliveryDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [delivery, setDelivery] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDelivery();
  }, [id]);

  const loadDelivery = async () => {
    try {
      const response = await deliveriesAPI.getById(id);
      setDelivery(response.data);
    } catch (error) {
      console.error('Error loading delivery:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading delivery...</div>;
  }

  if (!delivery) {
    return (
      <div className="page">
        <p>Delivery not found</p>
        <button onClick={() => navigate('/admin')} className="btn btn-secondary">
          Back to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="page delivery-detail-page">
      <button onClick={() => navigate('/admin')} className="btn btn-secondary">
        ← Back to Dashboard
      </button>

      <h1 className="page-title">Delivery Details</h1>

      <div className="card">
        <h2>Delivery Information</h2>
        <div className="detail-grid">
          <div className="detail-item">
            <span className="detail-label">Delivery ID:</span>
            <span className="detail-value">#{delivery.id}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Delivery Code:</span>
            <span className="detail-value code">{delivery.delivery_code}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Status:</span>
            <span className={`status-badge status-${delivery.status}`}>
              {delivery.status}
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Order ID:</span>
            <span className="detail-value">#{delivery.order_id}</span>
          </div>
          {delivery.driver_id && (
            <div className="detail-item">
              <span className="detail-label">Driver ID:</span>
              <span className="detail-value">#{delivery.driver_id}</span>
            </div>
          )}
          {delivery.pickup_event_id && (
            <div className="detail-item">
              <span className="detail-label">Pickup Event:</span>
              <span className="detail-value">
                <button
                  onClick={() => navigate(`/admin/pickup-events/${delivery.pickup_event_id}`)}
                  className="btn btn-link"
                >
                  View Pickup Event →
                </button>
              </span>
            </div>
          )}
        </div>

        {delivery.pickup_code && (
          <div className="pickup-code-display">
            <h3>Pickup Code</h3>
            <div className="code-large">{delivery.pickup_code}</div>
          </div>
        )}

        <div className="timestamps">
          {delivery.assigned_at && (
            <div className="timestamp-item">
              <span className="timestamp-label">Assigned:</span>
              <span>{new Date(delivery.assigned_at).toLocaleString()}</span>
            </div>
          )}
          {delivery.started_at && (
            <div className="timestamp-item">
              <span className="timestamp-label">Started:</span>
              <span>{new Date(delivery.started_at).toLocaleString()}</span>
            </div>
          )}
          {delivery.completed_at && (
            <div className="timestamp-item">
              <span className="timestamp-label">Completed:</span>
              <span>{new Date(delivery.completed_at).toLocaleString()}</span>
            </div>
          )}
          {delivery.created_at && (
            <div className="timestamp-item">
              <span className="timestamp-label">Created:</span>
              <span>{new Date(delivery.created_at).toLocaleString()}</span>
            </div>
          )}
        </div>

        {delivery.driver_notes && (
          <div className="notes-section">
            <h3>Driver Notes</h3>
            <p>{delivery.driver_notes}</p>
          </div>
        )}

        {delivery.photos && delivery.photos.length > 0 && (
          <div className="photos-section">
            <h3>Delivery Photos</h3>
            <div className="photos-grid">
              {delivery.photos.map((photo) => (
                <div key={photo.id} className="photo-item">
                  <img src={photo.photo_url} alt={photo.caption || 'Delivery photo'} />
                  {photo.caption && <p className="photo-caption">{photo.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DeliveryDetail;
